/* eslint-disable no-undef */

/* Global Vars */
var flickityCarousel;
var flickityCells;
var slickCarousel;
var slickCells;
const productJson = $('[data-product-json]').html();
const initialMediaId = JSON.parse(productJson).inital_media_id;
const product = JSON.parse(productJson).product;
var imageAutomator = new ImageAutomator({
  product: product,
});

$(document).ready(() => {
  // get the untouched media
  flickityCarousel = $('.Carousel');
  flickityCells = $('.Carousel__Cell');
  slickCarousel = $('.slick-slider');
  slickCells = $('.Product__SlideshowNavImage.slick-slide');
  const selectedVariantId = JSON.parse(productJson).selected_variant_id;
  const usedMediaIds = getVariantMediaIds(selectedVariantId);
  if (usedMediaIds) {
    displayVariantImagesSlick(slickCells, slickCarousel, usedMediaIds);
    displayVariantImagesFlickity(flickityCarousel, flickityCells, usedMediaIds, true);
  } else {
    initFlicktiy(flickityCarousel, true);
  }
});

$('#result').on('DOMSubtreeModified', () => {
  const variantTitle = $('#result').text();
  // empty variant titles are also detected.
  if (variantTitle === '') {
    return;
  }
  const variantId = getSelectedVariantId(variantTitle);
  const usedMediaIds = getVariantMediaIds(variantId);
  displayVariantImagesSlick(slickCells, slickCarousel, usedMediaIds);
  displayVariantImagesFlickity(flickityCarousel, flickityCells, usedMediaIds);
});

/**
 * Compares titles and returns id if match.
 * @param  {String} variantTitle
 * @return {String} variant id
 */
function getSelectedVariantId(variantTitle) {
  for (var i = 0; i < product.variants.length; i++) {
    if (product.variants[i].title == variantTitle) {
      return product.variants[i].id;
    }
  }
}

/**
 * @param  {jQuery} images
 */
function hideImages(images) {
  images.remove(0);
}

/**
 * Adds all relevant variant images to slick slider and initializes a new slider.
 * @param  {jQuery} images Jquery Object of the image cells
 * @param  {Array.<string>} mediaIdArray relevant media ids for variant
 * @param  {jQuery} slickCarousel slider carousel object
 */
function addVariantImagesToSlick(images, mediaIdArray, slickCarousel) {
  // somehow duplicates are a thing
  var alreadySeen = [];
  for (let i = 0; i < images.length; i++) {
    const currentMediaIndex = $(images[i]).attr('data-media-id');
    // if media Id is relevant for variant, add slider element.
    if (mediaIdArray.includes(currentMediaIndex)) {
      if (!alreadySeen.includes(currentMediaIndex)) {
        $(slickCarousel).slick('slickAdd', images[i]);
        // prevent default, because clicking would open new window.
        $(slickCarousel).click((event) => {
          event.preventDefault();
        });
        alreadySeen.push(currentMediaIndex);
      }
    }
  }
  // reinitialize slick carousel
  $('slick-slider').slick();
}

/**
 * Displays the correct images for a variant.
 * @param  {jQuery} slickCells
 * @param  {jQuery} slickCarousel
 * @param  {Array.<String>} usedMediaIds media ids of variant
 */
function displayVariantImagesSlick(slickCells, slickCarousel, usedMediaIds) {
  hideImages(slickCells);
  addVariantImagesToSlick(slickCells, usedMediaIds, slickCarousel);
}

/**
 * Maps media ids to an array for looping
 * @param  {String} selectedVariantId
 */
function getVariantMediaIds(selectedVariantId) {
  const media = imageAutomator.getVariantMedia(selectedVariantId);
  if (media) {
    return media.media.map((m) => m.id.toString());
  }
}

/**
 *
 * @param  {jQuery} carousel Flickity carousel
 * @param  {jQuery} cells Flickity cells
 * @param  {Array.<String>} usedMediaIds relevant media ids for variant
 * @param  {boolean} initial=false
 */
function displayVariantImagesFlickity(carousel, cells, usedMediaIds, initial = false) {
  // check if it has been initialized before, because it will throw an erro otherwise
  if (!initial) {
    carousel.flickity('destroy');
  }
  cells.remove();
  // somehow duplicates are a thing
  var alreadySeen = [];
  for (let i = 0; i < cells.length; i++) {
    const currentMediaIndex = $(cells[i]).attr('data-media-id');
    if (usedMediaIds.includes(currentMediaIndex)) {
      if (!alreadySeen.includes(currentMediaIndex)) {
        $(carousel).append(cells[i]);
        alreadySeen.push(currentMediaIndex);
      }
    }
  }
  initFlicktiy(carousel);
}

/**
 * Initializes the Flickity Components for later use.
 * Making a new Slider is neccessary because the amount of cells displayed
 * depends on the variant.
 * @param  {jQuery} carousel
 * @param  {boolean} initial=false only for initial use
 */
function initFlicktiy(carousel, initial = false) {
  if (initial) {
    carousel.flickity({
      prevNextButtons: true,
      pageDots: true,
      adaptiveHeight: true,
      watchCSS: true,
      dragThreshold: 8,
      draggable: matchMedia('screen and (max-width: 1007px)').matches,
      initialIndex: initialMediaId,
      arrowShape: {
        x0: 20,
        x1: 60,
        y1: 40,
        x2: 60,
        y2: 35,
        x3: 25,
      },
    });
  } else {
    carousel.flickity({
      prevNextButtons: true,
      pageDots: true,
      adaptiveHeight: true,
      watchCSS: true,
      dragThreshold: 8,
      draggable: matchMedia('screen and (max-width: 1007px)').matches,
      arrowShape: {
        x0: 20,
        x1: 60,
        y1: 40,
        x2: 60,
        y2: 35,
        x3: 25,
      },
    });
  }
}
